

import { Container } from 'inversify';
import { computed, defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';
import Environment from '../../../../common/domain/constantes/environment';
import { TYPES } from '../../../../common/domain/types';
import HelperLoading from '../../../../common/infrastructure/funciones/HelperLoading';
import { LocalService } from '../../../../common/infrastructure/servicios';
import CatalogCompConst from '../../catalog/domain/const/CatalogCompConst';
import { IapCatalogType } from '../../catalog/domain/iapCatalogType';
import { IServiceComponent } from '../../component/application/IServiceComponent';
import { IapComponent } from '../../component/domain/iapComponent';
import WidgetComponentDataTree from '../../designer/domain/widgetComponent';
import ComponentUtil from '../../designer/infrastructure/component/util/componentUtil';
import ExpressionNomenclatorConst from '../../expression/domain/const/ExpressionNomenclatorConst';
import ExpressionToolConst from '../../expression/domain/const/ExpressionToolConst';
import { Dictionary } from '../../expression/domain/dictionary';
import HelperCommon from '@ilinium/shared/src/common/infrastructure/funciones/HelperCommon';

import DynamicComponentBuilder from './DynamicComponentBuilder.vue'
import { fetchWrapper } from '../../../../common/infrastructure/funciones/helperFetch';
import { IapComponentDataSource } from '../../component/domain/iapComponentDataSource';
import CatalogAttrConst from '../../catalog/domain/const/CatalogAttrConst';
import HelperSecurity from '../../../../common/infrastructure/funciones/HelperSecurity';
import CatalogObjectTypeConst from '../../catalog/domain/const/CatalogObjectTypeConst';
import helperCatalog from '../../catalog/infrastructure/helper/helperCatalog';
import BaseControlTypeConst from '../domain/Constants/BaseControlTypeConst';
import CatalogExpConst from '../../catalog/domain/const/CatalogExpConst';
import ControlTypeConst from '../domain/Constants/ControlTypeConst';
import EventBus from '../../../../common/infrastructure/event-bus';
import EventConst from '../../../../common/domain/constantes/EventConst';
import { IapComponentAttribute } from '../../component/domain/iapComponentAttribute';
import { InteractionEvent } from '../../interaction/domain/interactionEvent';
import ComponentCommon from '../domain/Functions/ComponentCommon';
import InteractionConst from '../../interaction/domain/interactionConst';


export default defineComponent({
    name: 'form_builder',
    components: {
        DynamicComponentBuilder,


    },
    props:
    {
        container: {
            type: Object as () => Container
        },
        componentId: {
            type: Number,
            defaultValue: (-1)
        },
        applicationId: Number,
        applicationVersion: Number,
        preview: {
            type: Boolean,
            defaultValue: (false)
        },
        attrsInput: {
            type: Object as () => IapComponentAttribute[],
            defaultValue: ([])
        },
    },
    setup(props, context) {
        const store = useStore();
        const { nest, getTreeObject } = ComponentUtil();
        const ComponentsData = ref<WidgetComponentDataTree>();
        let dic: Dictionary<String, Object>[] = ([])
        const showComponentForm = ref(false);
        const componentInputModal = ref(false);
        const componentInputHeader = ref('');
        const componentInputId = ref(-1);
        const componentAttributesList = ref<IapComponentAttribute[]>([]);
        const showComponentFormDialog = ref(false);
        const keyEventComponent = (props?.componentId ?? -1).toString() + '_' + EventConst.SHOWCOMPONENT;
        const keyEventComponentRoot = (props?.componentId ?? -1).toString() + EventConst.INTERACTION;

        const catalogTypes = computed(() => {
            return helperCatalog.getAllCatalogApp();
        })


        const buildDictionary = (comps: IapComponent[]) => {


            const userData = [
                {
                    key: [ExpressionNomenclatorConst.EXPNOM_USER, ExpressionToolConst.EXPTOOL_NOMB].join('.'),
                    value: store.getters.getCurrentUser.fullName
                },
                {
                    key: [ExpressionNomenclatorConst.EXPNOM_USER, ExpressionToolConst.EXPTOOL_EM].join('.'),
                    value: store.getters.getCurrentUser.userName
                },
                {
                    key: [ExpressionNomenclatorConst.EXPNOM_USER, ExpressionToolConst.EXPTOOL_PROFILE].join('.'),
                    value: store.getters.getCurrentProfile
                },
                {
                    key: [ExpressionNomenclatorConst.EXPNOM_USER, ExpressionToolConst.EXPTOOL_LASTSESSION].join('.'),
                    value: HelperCommon.formateaFechaHoraLarga(store.getters.getCurrentUser.lastConnection)
                },
                {
                    key: [ExpressionNomenclatorConst.EXPNOM_USER, ExpressionToolConst.EXPTOOL_TRYFAIL].join('.'),
                    value: store.getters.getCurrentUser.loginTries
                }
                ,
                {
                    key: [ExpressionNomenclatorConst.EXPNOM_USER, ExpressionToolConst.EXPTOOL_MAINENTITYID].join('.'),
                    value: store.getters.getCurrentUser.entityMainId
                }
            ]


            dic = dic.concat(userData);

            //const expcab = comps.flatMap(x => x.expressions).filter(x => x).map(x => x.objetoId)
            const exptext = comps.flatMap(x => x.expressions).filter(x => x !== null).flatMap(x => x.iapExpressionDetails).filter(x => x !== null).map(x => x.expression).join("")
            const match = exptext.match(/\[.*?\]/g)

            if (match && match?.length > 0) {


                const clearKeys = match.map(x => x?.replaceAll('[', '').replaceAll(']', ''))

                const atts = comps.flatMap(x => x.iapComponentAttributes).filter(x => clearKeys.includes([ExpressionNomenclatorConst.EXPNOM_ATTRIBUTES, x.id].join('.'))).map(x => ({
                    key: [ExpressionNomenclatorConst.EXPNOM_ATTRIBUTES, x.id].join('.'),
                    value: x.value
                }) as Dictionary<String, Object>);

                dic = dic.concat(atts.flatMap(x => x))

                const ds = comps.flatMap(x => x.iapComponentDataSources).filter(x => clearKeys.includes([ExpressionNomenclatorConst.EXPNOM_DATASOURCE, x.id, x.dataSourceId, x.componentId].join('.'))).map(x => ({
                    key: [ExpressionNomenclatorConst.EXPNOM_DATASOURCE, x.id, x.dataSourceId, x.componentId].join('.'),
                    value: x.dataSource.items
                }) as Dictionary<String, Object>);

                dic = dic.concat(ds.flatMap(x => x))

                comps.flatMap(x => x.iapComponentDataSources).forEach(dsf => {
                    const newdsf = dsf.dataSource.iapDataSourceFields.filter(x => clearKeys.includes([ExpressionNomenclatorConst.EXPNOM_DSF, dsf.id, x.id].join('.'))).map(x => ({
                        key: [ExpressionNomenclatorConst.EXPNOM_DSF, dsf.id, x.id].join('.'),
                        value: null as any
                    }) as Dictionary<String, Object>)

                    dic = dic.concat(newdsf.flatMap(x => x))

                    dsf.dataSource.iapDataSourceFields.filter(x => x.dataSourceLookUpId != null)
                        .map(x => ({ dataSourceFieldId: x.id, dataSourceLookUpId: x.dataSourceLookUpId, iapDataSourceFields: x.dataSourceLookUp?.dataSource.iapDataSourceFields }))
                        .forEach(x => {
                            const newdsflk = x.iapDataSourceFields?.filter(dsf => clearKeys.includes([ExpressionNomenclatorConst.EXPNOM_DSLK, x.dataSourceLookUpId, dsf.id].join('.'))).map(dsf => ({
                                key: [ExpressionNomenclatorConst.EXPNOM_DSLK, x.dataSourceLookUpId, dsf.id].join('.'),
                                value: null as any
                            }) as Dictionary<String, Object>)


                            if (newdsflk) {
                                dic = dic.concat(newdsflk.flatMap(x => x))
                            }


                        })

                });


                const catalogData = builtCatalogDictionary();

                //metemos catalogos
                dic = dic.concat(catalogData.filter(x => clearKeys.includes(x.key)));


            }

            dic = dic.filter((a, i) => dic.findIndex((s) => a.key === s.key) === i);
            LocalService.setValue(LocalService.COMPONENTS_EXP + (props?.componentId ?? -1).toString(), JSON.stringify(dic))

        }


        const setAttributesInput = (comps: IapComponent[]) => {
            if (props.attrsInput) {
                const clearKeys = props.attrsInput.map(x => x.id);
                const atts = comps.flatMap(x => x.iapComponentAttributes).filter(x => clearKeys.includes(x.id)).map((attr: IapComponentAttribute) => {
                    const itemAttr = props.attrsInput?.find(x => x.id == attr.id);
                    if (itemAttr) {
                        attr.value = itemAttr.value
                    }

                });

            }

        }




        const builtCatalogDictionary = () => {

            return catalogTypes.value.filter(x=> x != null).flatMap(x => x.iapCatalogs).map(x => ({ key: [ExpressionNomenclatorConst.EXPNOM_CATALOG, x.id].join('.'), value: x.id }));

        };

        // DEPRECATED: 05/12/2023 Creemos que ya no es necesario
        const addLookUpControlsRef = (components: IapComponent[]) => {


            const ids = [] as Array<number>;// components.flatMap(x=> x.iapComponentDataSources).filter(x=> x.dataSource.iapDataSourceFields.find(f => f.dataSourceLookUpId)).map(x=> x.componentId);
            const maps = components.flatMap(x => x.iapComponentDataSources).flatMap(x => x.dataSource.iapDataSourceFields).filter(t => t.dataSourceLookUp != null).flatMap(d => d.dataSourceLookUp?.iapDataSourceLookUpFieldMaps).filter(fm => fm && !HelperCommon.isNullOrWhitespace(fm.dataSourceFieldIdTarget)).map(fm => fm?.dataSourceFieldIdTarget)
            const attrs = components.flatMap(x => x.iapComponentAttributes).filter(x => x.value && x.name == BaseControlTypeConst.MODELVALUE && maps.find(m => m && x.value.startsWith(m))).map(x => x.componentId)
            const exps = components.flatMap(x => ({ componentId: x.id, expressions: x.expressions })).filter(x => x.expressions && x.expressions.find(e => e.idTypeExpression == CatalogExpConst.EXP_FILTERLK)).map(x => x.componentId);
            const looksUpEditor = components.filter(x => x.idType == ControlTypeConst.CTLOOKUPEDITOR).map(x => x.id)
            const maps1 = [] as Array<number>; //components.flatMap(x=> x.iapComponentDataSources).flatMap(x=> ({componentId:x.componentId,iapDataSourceFields:x.dataSource.iapDataSourceFields}) ).filter(t=> t.iapDataSourceFields.find(y=> y.dataSourceLookUpId != null)).flatMap(d => d.componentId);
            //.filter(x=> x.name == BaseControlTypeConst.MODELVALUE && maps.includes(x.value)).map(x=> x.componentId)

            const refControlsIds = [...new Set(ids.concat(attrs, exps, looksUpEditor, maps1))]
            LocalService.setValue(LocalService.COMPONENTS_CTRL + (props?.componentId ?? -1).toString(), JSON.stringify(refControlsIds))

        }

        const loadFromDataBase = () => {
            if (props.container) {
                HelperLoading.showLoading()
                const _srv = props.container.get<IServiceComponent>(TYPES.COMPONENT_REPOSITORY)
                _srv.getTreeAllObjectsById(props.applicationId ?? -1, props.applicationVersion ?? -1, props.componentId ?? -1).then(response => {

                    const root: Partial<IapComponent> = ({
                        id: -1,
                        applicationId: props.applicationId,
                        applicationVersion: props.applicationVersion,
                        parentId: null,
                        name: 'root',
                        description: 'Nodo ficticio',
                        active: true,
                        idType: CatalogCompConst.COMPONENTSAPP_COMP,
                        order: -1,
                    })

                    const parent = response.find(x => x != undefined)
                    if (parent) {
                        parent.parentId = -1;
                    }

                    const root1 = {
                        ...root,
                        loaded: false
                    }
                    response = response.map(o => ({ ...o, loaded: false }));

                    setAttributesInput(response);
                    ComponentsData.value = nest([root1, ...response], null, 'parentId')?.find(x => x !== undefined) as WidgetComponentDataTree
                    buildDictionary(response)

                    //addLookUpControlsRef(response)

                    response = []



                })
                    .finally(() => {
                        HelperLoading.hideLoading()
                    })
            }
        }

        const loadFromFile = () => {
            HelperLoading.showLoading()
            const token = store.getters.getAcessToken;
            fetchWrapper.get(Environment.URL_COMPONENT + props.componentId + '.json' + '?_t=' + new Date().getTime().toString())
                .then((response: IapComponent[]) => {
                    const filteredIds = HelperSecurity.checkObjectAccess(response.map(c => ({ id: c.id, idType: c.idType })), CatalogObjectTypeConst.COMP)
                    response = response.filter(r => filteredIds.filter(f => f == r.id).length > 0)

                    const root: Partial<IapComponent> = ({
                        id: -1,
                        applicationId: props.applicationId,
                        applicationVersion: props.applicationVersion,
                        parentId: null,
                        name: 'root',
                        description: 'Nodo ficticio',
                        active: true,
                        idType: CatalogCompConst.COMPONENTSAPP_COMP,
                        order: -1,
                    })

                    const parent = response.find(x => x != undefined)
                    if (parent) {
                        parent.parentId = -1;
                    }

                    const root1 = {
                        ...root,
                        loaded: false
                    }
                    response = response.map(o => ({ ...o, loaded: false }));
                    setAttributesInput(response);
                    ComponentsData.value = nest([root1, ...response], null, 'parentId')?.find(x => x !== undefined) as WidgetComponentDataTree

                    buildDictionary(response)

                    //addLookUpControlsRef(response)

                    response = []

                })
                .catch((response) => {
                    loadFromDataBase();

                })
                .finally(() => {
                    HelperLoading.hideLoading()
                })
        }

        const getComponenstDataSources = computed(() => {
            const dsc = getTreeObject(ComponentsData.value, "iapComponentDataSources")
            return dsc.flatMap(x => x);
        })

        const getRootAttributes = computed(() => {
            return ComponentsData.value?.children[0].iapComponentAttributes?.filter(x => x.idAttributeType == CatalogAttrConst.TIPOATTR_PROPCUS) ?? [];
        })

        const backToOtherComponent = () => {
            showComponentForm.value = false;
            componentInputModal.value = false;
            showComponentFormDialog.value = false;
            componentInputId.value = -1;
            componentAttributesList.value = [];
            componentInputHeader.value = '';
        }

        const doOperationEvent = (evt: { data: InteractionEvent, callBackResponse: any }) => {
            if (ComponentsData.value) {


                const Component = ComponentsData.value.children[0]
                switch (evt.data.typeId) {
                    case InteractionConst.GET_PROPERTY_VALUE:

                        const attrGet = Component.iapComponentAttributes?.find(x => x.id == evt.data.objectId || x.name == evt.data.objectName)
                        if (attrGet) {
                            evt.data.interactionResult = attrGet.value;
                        }

                        break;
                        case InteractionConst.CALL_FUNCTION:
        
                        if (evt.data.objectName?.toLowerCase() == 'getcurrentexpr()') {
                            evt.data.interactionResult = Component.expressions ?? []
                        }
                        
                        break;

                }

                if (evt.callBackResponse) {
                    evt.callBackResponse(evt.data);
                }
            }
        }

        onMounted(() => {
            // para los modales o formularios de detalle
            EventBus.on(keyEventComponent, (evt: { componentId: number, header: string, modal: boolean, attrs: IapComponentAttribute[], callBackResponse: any }) => {
                componentInputModal.value = evt.modal;
                componentInputId.value = evt.componentId;
                componentAttributesList.value = evt.attrs;
                showComponentFormDialog.value = evt.modal;
                componentInputHeader.value = evt.header;
                showComponentForm.value = true
                if (evt.callBackResponse) {
                    evt.callBackResponse(true)
                }
            })

            // para leer cosas del padre
            EventBus.on(keyEventComponentRoot, (evt: { data: InteractionEvent, callBackResponse: any }) => {
                doOperationEvent(evt);
            })


            if (props.preview) {
                loadFromDataBase();
            }
            else {

                loadFromFile();
            }
        })



        onUnmounted(() => {
            LocalService.destroy(LocalService.COMPONENTS_EXP + (props?.componentId ?? -1).toString());
            LocalService.destroy(LocalService.COMPONENTS_CTRL + (props?.componentId ?? -1).toString());
            EventBus.off(keyEventComponent, (evt: { componentId: number, header: string, modal: boolean, attrs: IapComponentAttribute[], callBackResponse: any }) => { })
            EventBus.off(keyEventComponentRoot, (evt: { data: InteractionEvent, callBackResponse: any }) => { });
        })

        return {
            ComponentsData,
            builtCatalogDictionary,
            Environment,
            getComponenstDataSources,
            getRootAttributes,
            catalogTypes,
            showComponentForm,
            backToOtherComponent,
            componentInputModal,
            componentInputId,
            componentAttributesList,
            showComponentFormDialog,
            componentInputHeader

        };
    },
});
